<template>
    <layout-main :banner="banner" subtitle="医疗机器人">
        <template v-slot:content>
            <p class="text">目前随着老龄化人口增多，以及受环境气候的影响看病就医的人数每年都在增加，各个地区医疗资源配比不均衡，有的地区医院人流量非常大，而作为护士是直接服务病人的，护士的工作量也有增无减。随着信息化技术的发展，为了解放护士双手，减轻护士工作量，移动护理系统、医生查房、输液监控、病房呼叫等信息化系统在很多医院已经上线，信息化系统多而且系统之间没有数据共享、势必会带来新的问题，增加护士新的工作量，要学习使用不同的系统，要通过人工的方式实现系统之间数据的录入，随着人工智能和5G技术的发展，使得机器人在医院的应用成为现实，通过机器人代替护士部分工作，来减轻护士工作量，解决医院护士缺口问题，实现机器人门诊导航、病区辅助智慧护理，更好的服务病人、解决社会问题。</p>
            <img src="@/assets/medicalRobots/image1.png" alt="" class="image1">
            <div class="title weight"> 产品特征 </div>
            <p class="text weight">· 健康宣教：入院场景、住院场景、手术场景及出院场景</p>
            <p class="text weight">· 门诊导航：智能问答、科室查询、医院介绍、业务指引、三维人体图；</p>
            <p class="text weight">· 远程探视：借助医护机器人的网络及视频系统，实现病人家属、病人以及第三方人员之间进行视频、语音等形式面对面交流。</p>
            <p class="text weight">· 远程查房：危险环境病房远程查房。</p>
            <p class="text weight">· 智能问答：借助医护机器人的智能语音识别及语音合成技术，基于云端智能问答知识库，实现智能问答。</p>
        </template>
    </layout-main>
</template>
<script>
import layoutMain from '@/components/layout-main.vue'
import banner from '@/assets/assets/banner.png'
export default {
  components: {
      layoutMain,
      
  },
  data () {
      return {
          banner: banner
      }
  }
}
</script>
<style lang="scss" scoped>
.weight{
    font-weight: 600;
    line-height: 3 !important;
}
.title{ 
    text-indent: 1.5em;
    font-size: 25px;
    text-align: left;
    margin: 20px 0;
}
.text{
    line-height: 2;
}
.image1{
    width: 100%;
    margin: 50px 0;
}
</style>
